import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonDataService } from './common-data.service';
import { first } from 'rxjs/operators';

@Injectable()
export class RoleGuard implements CanActivate {

    modelData: any;
    seller = false;

    constructor(private router: Router, private _data: CommonDataService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (this.getUserRole()) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/sellers/register/user-details'], { queryParams: { returnUrl: state.url }});
        return false;
    }

    private getUserRole() : boolean {

        let sessionUser = sessionStorage.getItem('BNFGSHGFGG');
        if (sessionUser && sessionUser == 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045') {
            // logged in so return true
            return true;
        }

        return false
        

        //return this.seller;

    }

    private userHasAccess() {

    }
}